module.exports = __webpack_public_path__ + "img/time_line_diamond.091f3f31.svg";